<template>
    <router-link :to="to" :class="buttonClassName">
        <slot></slot>
    </router-link>
</template>

<script>

    import mixin from './button-mixin.js';

    export default {
        mixins: [mixin],
        props: ['to']
    }
</script>
